import { render, staticRenderFns } from "./WellnessRing.vue?vue&type=template&id=22091bdf&scoped=true"
import script from "./WellnessRing.vue?vue&type=script&lang=js"
export * from "./WellnessRing.vue?vue&type=script&lang=js"
import style0 from "./WellnessRing.vue?vue&type=style&index=0&id=22091bdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22091bdf",
  null
  
)

export default component.exports